import styled from 'styled-components';
import { Button } from '@hiiretail/synergy-ui';

export const AccessDeniedButton = styled(Button)`
  cursor: not-allowed;
  pointer-events: none;
  &:active {
    pointer-events: none;
  }
`;
